import { render, staticRenderFns } from "./applyPublishers.vue?vue&type=template&id=7dafcede&scoped=true&"
import script from "./applyPublishers.vue?vue&type=script&lang=js&"
export * from "./applyPublishers.vue?vue&type=script&lang=js&"
import style0 from "./applyPublishers.vue?vue&type=style&index=0&id=7dafcede&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dafcede",
  null
  
)

export default component.exports